export default __webpack_public_path__ + "static/0048-22b356324a2f8dda4f81103bfaab97c9.png";